module.exports = __webpack_public_path__ + "img/fm-Path 41 Copy@3x.c4858519.png";